export default [
    {
        title: 'مدیریت مشاوره ها',
        icon: 'bx bx-chalkboard',
        children: [
            {
                title: 'دسته‌بندی‌ها',
                route: { name: 'consultingcategory' },
                resource: 'ConsultingCategoryManager',
                action: 'show',
            },
            {
                title: 'مشاوران',
                route: { name: 'consultingprofile' },
                resource: 'ConsultingProfileManager',
                action: 'show',
            },
            {
                title: 'رزروها',
                route: { name: 'consultingbooking' },
                resource: 'ConsultingProfileManager',
                action: 'show',
            },
            {
                title: 'نظرات',
                route: { name: 'consultingreview' },
                resource: 'ConsultingProfileManager',
                action: 'show',
            },
        ],
    },
]
